import PageContainer from "../../components/dashboard/PageContainer";

const Profile = () => {
  return (
    <PageContainer
      title="Profile">
      {/* content here */}
    </PageContainer>
  )
};

export default Profile;
